<div class="row" [ngClass]="{ 'mt-4 mb-4': mappedData && mappedData.length > 0 }">
  <div *ngFor="let data of mappedData; last as isLast" class="col-6 col-md-4 col-lg-3 mb-4">
    <div class="card product-card colmec-product-card-container">
      <div class="card-body text-center">
        <div
          class="image-wrapper"
          (click)="
            data.product.productType === 'singleDimension' ? goToDetail(data.product) : goToDetailConcept(data.product)
          "
        >
          <img
            class="img-fluid"
            *ngIf="
              data.product.productType === 'singleDimension'
                ? data.product.extra.images && data.product.extra.images[0]
                : data.product.images && data.product.images[0] as image;
              else noimage
            "
            src="https://cdn1.gung.io/fit-in/250x250/filters:fill(white):background_color(white):etag({{
              image.s3ETag
            }}):format(jpeg)/{{ image.s3Uri }}"
            alt=""
          />
          <ng-template #noimage>
            <img
              class="card-img-top img-fluid w-100"
              src="https://cdn1.gung.io/fit-in/300x300/images/no-image.jpg"
              alt="NO IMAGE"
              class="img-fluid mx-auto d-block"
            />
          </ng-template>
        </div>
        <div class="product-text">
          <i class="fas fa-box product-availability-box-icon"></i>&nbsp;
          <lib-availability [availability]="data.availability" *ngIf="data.availability"></lib-availability>
          <div class="text-truncate" translate>{{ data.product.name }}</div>
          <div class="small">{{ data.product.extra.ar?.artbeskrspec }}</div>
          <small
            >{{ 'ITEM_NO' | translate }}: <span translate>{{ data.product.id }}</span></small
          >
          <colmec-product-symbols [product]="data.product"></colmec-product-symbols>
          <div *ngIf="data.product.productType !== 'singleDimension'">{{ data.product.extra.description }}</div>
          <div translate *ngIf="data.price" [class.d-none]="hidePrice">
            <div *ngIf="data.price.customerGrossPrice.value != data.price.customerNetPrice.value">
              <div class="pt-1" translate>GROSS_PRICE</div>
              <div>
                {{ data.price.customerGrossPrice.value | gungCurrency: data.price.customerGrossPrice.currencyCode }}
              </div>
              <div class="pt-1" [class.d-none]="hidePrice" translate>DISCOUNT</div>
              <div *ngIf="data.price.customerDiscountPercent !== 0" [class.d-none]="hidePrice">
                (-{{ data.price.customerDiscountPercent }}%)
              </div>
            </div>

            <div class="pt-1" [class.d-none]="hidePrice">{{ getNetPriceLabel(data.product) | async }}</div>
            <div [class.d-none]="hidePrice">
              {{ getNetPriceValue(data.price) | gungCurrency: data.price.customerNetPrice.currencyCode }}
            </div>
          </div>
        </div>
      </div>
      <colmec-buy-btn
        *ngIf="data.product.productType === 'singleDimension'; else conceptButton"
        [product]="data.product"
        [id]="data.product.id"
      ></colmec-buy-btn>
      <ng-template #conceptButton>
        <button
          type="button"
          class="btn btn-primary btn-sm go-to-product"
          (click)="goToDetailConcept(data.product)"
          translate
        >
          SEE_PRICE_PER
        </button>
      </ng-template>
    </div>
  </div>
</div>
